<template>
  <b-row>
    <b-col>
      <fieldset class="font-weight-bold text-muted small">
        {{ descricao }}
      </fieldset>
    </b-col>
    <b-col cols="12">
      <hr
        class="mx-0 mt-0 mb-2"
        style="border-top: 1px solid #a3a4a66b !important;"
      >
    </b-col>
    <b-form-group
      label="Descrição"
      class="col-9"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Descrição"
      >
        <b-input
          v-model="form.descricao"
          placeholder="Insira uma descrição"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- <b-form-group
      label="Template"
      class="col-3"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Template"
      >
        <b-form-select
          v-model="form.templateVinculo"
          :options="templateOptions"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group> -->

    <b-form-group
      label="Tipo de proposta"
      class="col-4"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Tipo proposta"
      >
        <b-select
          v-model="form.tipoProposta"
          :options="propostaOptions"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <b-form-group
      class="col-4"
    >
      <tipo-tributacao-select
        v-model="form.tiposTributacao"
        :multiple="true"
      />
    </b-form-group>

    <b-form-group
      class="col-4"
    >
      <tipo-atividade-select
        v-model="form.tiposAtividade"
        :multiple="true"
      />
    </b-form-group>

    <!-- <b-col cols="2">
      <b-form-group label="Matriz/Filial">
        <b-select
          v-model="form.matriz"
          :options="matrizOpcoes"
          @change="mudarOpcoesTipo"
        />
      </b-form-group>
    </b-col> -->
    <!-- <b-col cols="3">
      <b-form-group label="Nível">
        <validation-provider
          #default="{ errors }"
          :rules="(form.matriz)? 'required' : ''"
          name="Nível"
        >
          <b-select
            v-model="form.nivel"
            :disabled="!form.matriz"
            :options="nivelOpcoes"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col> -->
    <!-- <b-col cols="3">
      <b-form-group label="Tipo">
        <validation-provider
          #default="{ errors }"
          :rules="(form.matriz === null || form.matriz === undefined)? 'required' : ''"
          name="Tipo"
        >
          <b-select
            v-model="form.tipoTemplate"
            :disabled="form.matriz !== undefined && form.matriz === false"
            :options="tipoOpcoes"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col> -->
  </b-row>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.ql-editor {
  height: 800px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import TipoAtividadeSelect from '@/shared/components/tipo-atividade-select/TipoAtividadeSelect.vue'
import TipoTributacaoSelect from '@/shared/components/tipo-tributacao-select/TipoTributacaoSelect.vue'

export default {
  name: 'CadastroTemplateProposta',
  components: {
    ValidationProvider,
    TipoAtividadeSelect,
    TipoTributacaoSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      form: {
        templateVinculo: 'proposta',
        tipoTemplate: null,
      },
      templateOptions: [
        { value: 'proposta', text: 'Proposta' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'semchecklist', text: 'Proposta de serviços eventuais' },
        { value: 'transferencia', text: 'Proposta honorários empresas em transferência' },
        { value: 'constituicaotransferencia', text: 'Proposta honorários empresas em constituição & transferência' },
      ],
      nivelOpcoes: [
        { value: 'nivel1', text: 'Nível I - Básico' },
        { value: 'nivel2', text: 'Nível II - Essencial' },
        { value: 'nivel3', text: 'Nível III - Avançado' },
      ],
      matrizOpcoes: [
        { value: null, text: '' },
        { value: true, text: 'Matriz' },
        { value: false, text: 'Filial' },
      ],
      tipoOpcoes: [{ value: null, text: '' }],
      tipoOpcoesMatriz: [{ value: 'simplesnacional', text: 'Simples Nacional' }],
      tipoOpcoesFilial: [{ value: 'recursoshumanos', text: 'Recursos Humanos' }, { value: 'mei', text: 'MEI' }, { value: 'consultoria', text: 'Consultoria' }, { value: 'domestica', text: 'Serviço Doméstico' }],
    }
  },
  wacth: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.selecionarOpcoesTipo()
        this.form = value
      }
    },
  },
  created() {
    this.selecionarOpcoesTipo()
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    this.form = this.value
  },
  methods: {
    mudarOpcoesTipo() {
      this.form.nivel = null
      this.form.tipoTemplate = null
      this.selecionarOpcoesTipo()
    },
    selecionarOpcoesTipo() {
      this.form = this.value
      this.tipoOpcoes = [{ value: null, text: '' }]
      if (!this.form.matriz) {
        this.tipoOpcoes.push(...this.tipoOpcoesFilial)
      } else {
        this.tipoOpcoes.push(...this.tipoOpcoesMatriz)
      }
    },
  },
}
</script>
